import mapFunction from './mapResources';

export default mapFunction('order_document_material_items', {
    isFetching: false,
    items: []
});